import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'packageSpots'
})
export class PackageSpotsPipe implements PipeTransform {
  transform(packageList: any[]): number {
    let totalSpots = 0;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          totalSpots += pkg.items.reduce((acc: number, item: any) => {
            if (item.requiredSpots) {
              acc += (item.requiredSpots * (item.count || 1));
            }
            return acc;
          }, 0);
        }
      });
    }

    return totalSpots;
  }
}





// import { Pipe, PipeTransform } from '@angular/core';
//
// @Pipe({
//   name: 'packageSpots'
// })
// export class PackageSpotsPipe implements PipeTransform {
//   transform(packageRef: any): number {
//     let spotsSum = 0;
//
//     if (packageRef && packageRef.items && packageRef.items.length) {
//       spotsSum = packageRef.items.reduce((acc: number, item: any) => {
//         if (item.requiredSpots) {
//           acc += (item.requiredSpots * (item.count || 1));
//         }
//         return acc;
//       }, 0);
//     }
//     return spotsSum;
//   }
// }
